import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';

import * as ProformaActions from '@core/actions/proforma.actions';
import * as fromProforma from '@core/reducers/proforma.reducer';

@Component({
  selector: 'app-departmentSheet-edit',
  templateUrl: './departmentSheet-edit.component.html',
  styleUrls: ['./departmentSheet-edit.component.css'],
})

export class DepartmentSheetEdit implements OnInit {
  constructor(
    private ngProgress: NgProgress,
    private store: Store<any>,
  ){}

  progressRef: NgProgressRef;

  n2Departments$ = this.store.pipe(select(fromProforma.getn2Departments));

  ngOnInit() {
    this.progressRef = this.ngProgress.ref();
    this.store.dispatch(new ProformaActions.N2Department())
  }
}